import { JitsiMeeting } from '@jitsi/react-sdk';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { useDisclosure, VStack } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingImg from 'components/LoadingImg';

import { FaMicrophone } from 'react-icons/fa6';
import { MdCallEnd } from 'react-icons/md';
import { FaCamera } from 'react-icons/fa';
import { FaMicrophoneAltSlash } from 'react-icons/fa';
import { FaPaperclip } from 'react-icons/fa';

import { LuCameraOff } from 'react-icons/lu';
import useModelVideoChamada from './useModelVideoChamada';
import ModalAnexoChamada from './AnexoChamada/ModalAnexoChamada';
import { AccountContext } from 'components/AccountContext';
import SairChamada from './sairChamada/SairChamada';

function VideoChamada() {
  const { socket } = useContext(AccountContext);
  const navigate = useNavigate();
  const state = useLocation();
  const { agenda_exames_id, channelName, userId, jwt } = state?.state;

  const apiRef = useRef();
  const [logItems, updateLog] = useState([]);
  const [showNew, toggleShowNew] = useState(false);
  const [knockingParticipants, updateKnockingParticipants] = useState([]);
  //audio e camera
  const [audioMuted, setAudioMuted] = useState(false);
  const [cameraMuted, setCameraMuted] = useState(false);
  const { chamadafinalizada, getStatusChamada } = useModelVideoChamada({ agenda_exames_id: agenda_exames_id });
  const anexoChamda = useDisclosure();
  const sairdaChamada = useDisclosure();

  const printEventOutput = (payload) => {
    updateLog((items) => [...items, JSON.stringify(payload)]);
  };

  const handleAudioStatusChange = (payload, feature) => {
    if (payload.muted) {
      setAudioMuted(true);
      updateLog((items) => [...items, `${feature} off`]);
    } else {
      setAudioMuted(false);
      updateLog((items) => [...items, `${feature} on`]);
    }

    // setAudioMuted((prev) => !prev);
  };

  const handleCameraStatusChange = (payload, feature) => {
    setCameraMuted((prev) => !prev);
  };

  const handleChatUpdates = (payload) => {
    if (payload.isOpen || !payload.unreadCount) {
      return;
    }
    apiRef.current.executeCommand('toggleChat');
    updateLog((items) => [...items, `you have ${payload.unreadCount} unread messages`]);
  };

  const handleKnockingParticipant = (payload) => {
    updateLog((items) => [...items, JSON.stringify(payload)]);
    updateKnockingParticipants((participants) => [...participants, payload?.participant]);
  };

  const resolveKnockingParticipants = (condition) => {
    knockingParticipants.forEach((participant) => {
      apiRef.current.executeCommand('answerKnockingParticipant', participant?.id, condition(participant));
      updateKnockingParticipants((participants) => participants.filter((item) => item.id === participant.id));
    });
  };

  const handleJitsiIFrameRef1 = (iframeRef) => {
    // iframeRef.style.border = "10px solid #3d3d3d";
    // iframeRef.style.background = "#3d3d3d";
    iframeRef.style.height = '100%';
    // iframeRef.style.marginBottom = "20px";
  };

  const handleApiReady = (apiObj) => {
    console.log('apiObj', apiObj);
    apiRef.current = apiObj;
    apiRef.current.on('knockingParticipant', handleKnockingParticipant);
    apiRef.current.on('audioMuteStatusChanged', (payload) => handleAudioStatusChange(payload, 'audio'));
    apiRef.current.on('videoMuteStatusChanged', (payload) => handleCameraStatusChange(payload, 'video'));
    apiRef.current.on('raiseHandUpdated', printEventOutput);
    apiRef.current.on('titleViewChanged', printEventOutput);
    apiRef.current.on('chatUpdated', handleChatUpdates);
    apiRef.current.on('knockingParticipant', handleKnockingParticipant);
  };

  const handleReadyToClose = () => {
    sairdaChamada.onOpen();
    /*
      socket.emit('leaveTelemedicina', agenda_exames_id);
      socket.on('teleLeft', (msg) => {}); 
    */

    /* 
    const env = process.env;
    if (env === 'development') {
      window.location.href = `https://${process.env.REACT_APP_URL_DEOVITA_TEST}/fpinheiro/deovita/login/avaliacaopaciente/${agenda_exames_id}`;
    } else {
      //REACT_APP_URL_DEOVITA_PROD 
      window.location.href = `https://${process.env.REACT_APP_URL_DEOVITA_PROD}/deovita/login/avaliacaopaciente/${agenda_exames_id}`;
    }
      */
  };

  useEffect(() => {
    setAudioMuted(audioMuted);
  }, [audioMuted]);

  useEffect(() => {
    const interval = setInterval(() => {
      getStatusChamada();
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (chamadafinalizada) {
      navigate('/video-chamada/avaliacao', {
      state: {
        agenda_exames_id,
      },
    });
    }
  }, [chamadafinalizada]);

  const renderButtons = () => (
    <div style={{ position: 'absolute', bottom: '0', left: '0', right: '0', height: '40px', margin: '15px 0', marginBottom: '1.5em' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <button
          type="text"
          title="Click to execute toggle raise hand command"
          style={{
            border: 0,
            borderRadius: '6px',
            fontSize: '14px',
            background: 'white',
            color: 'red',
            padding: '4px 8px',
            margin: '2px 2px',
            height: '2em',
            width: '3em',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
          }}
          onClick={() => handleReadyToClose()}
        >
          <MdCallEnd fill="red" size={32} />
        </button>
        <button
          type="text"
          title="Click to execute toggle raise hand command"
          style={{
            border: 0,
            borderRadius: '6px',
            fontSize: '14px',
            background: 'white',
            color: 'red',
            padding: '4px 8px',
            margin: '2px 2px',
            height: '2em',
            width: '3em',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            marginLeft: '1em',
          }}
          onClick={() => apiRef.current.executeCommand('toggleAudio')}
        >
          {!audioMuted ? <FaMicrophone fill="red" size={20} /> : <FaMicrophoneAltSlash fill="red" size={20} />}
        </button>
        <button
          type="text"
          title="Click to execute toggle raise hand command"
          style={{
            border: 0,
            borderRadius: '6px',
            fontSize: '14px',
            background: 'white',
            color: 'red',
            padding: '4px 8px',
            margin: '2px 2px',
            height: '2em',
            width: '3em',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            marginLeft: '1em',
          }}
          onClick={() => apiRef.current.executeCommand('toggleVideo')}
        >
          {!cameraMuted ? <FaCamera fill="red" size={20} /> : <LuCameraOff fill="red" size={20} />}
        </button>

        <button
          type="text"
          title="Click to execute toggle raise hand command"
          style={{
            border: 0,
            borderRadius: '6px',
            fontSize: '14px',
            background: 'white',
            color: 'red',
            padding: '4px 8px',
            margin: '2px 2px',
            height: '2em',
            width: '3em',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            marginLeft: '1em',
          }}
          onClick={() => anexoChamda.onOpen()}
        >
          <FaPaperclip fill="red" size={20} />
        </button>
        {/* <button
          type="text"
          title="Click to execute toggle raise hand command"
          style={{
            border: 0,
            borderRadius: "6px",
            fontSize: "14px",
            background: "#f8ae1a",
            color: "#040404",
            padding: "4px 8px",
            margin: "2px 2px",
          }}
          onClick={() => apiRef.current.executeCommand("toggleRaiseHand")}
        >
          Raise hand
        </button> */}
        {/* <button
          type="text"
          title="Click to approve/reject knocking participant"
          style={{
            border: 0,
            borderRadius: "6px",
            fontSize: "14px",
            background: "#0056E0",
            color: "white",
            padding: "12px 46px",
            margin: "2px 2px",
          }}
          onClick={() =>
            resolveKnockingParticipants(({ name }) => !name.includes("test"))
          }
        >
          Resolve lobby
        </button> */}
        {/* <button
          type="text"
          title="Click to execute subject command"
          style={{
            border: 0,
            borderRadius: "6px",
            fontSize: "14px",
            background: "#df486f",
            color: "white",
            padding: "12px 46px",
            margin: "2px 2px",
          }}
          onClick={() =>
            apiRef.current.executeCommand("subject", "New Subject")
          }
        >
          Change subject
        </button> */}
        {/* <button
          type="text"
          title="Click to create a new JitsiMeeting instance"
          style={{
            border: 0,
            borderRadius: "6px",
            fontSize: "14px",
            background: "#3D3D3D",
            color: "white",
            padding: "12px 46px",
            margin: "2px 2px",
          }}
          onClick={() => toggleShowNew(!showNew)}
        >
          Toggle new instance
        </button> */}
        {/* <button
          type="text"
          title="Click to create a new JitsiMeeting instance"
          style={{
            border: 0,
            borderRadius: "6px",
            fontSize: "14px",
            background: "#3D3D3D",
            color: "white",
            padding: "12px 46px",
            margin: "2px 2px",
          }}
          onClick={() => {
            console.log('apiRef.current',apiRef.current.getSupportedEvents());
          }}
        >
          test
        </button> */}
      </div>
    </div>
  );

  const renderLog = () =>
    logItems.map((item, index) => (
      <div
        style={{
          fontFamily: 'monospace',
          padding: '5px',
        }}
        key={index}
      >
        {item}
      </div>
    ));

  const renderSpinner = () => (
    <div
      style={{
        fontFamily: 'sans-serif',
        textAlign: 'center',
      }}
    >
      Loading..
    </div>
  );

  return (
    <>
      <SairChamada disclosure={sairdaChamada} />
      <ModalAnexoChamada disclosure={anexoChamda} agenda_exames_id={agenda_exames_id} />
      <VStack w={'100%'} h={'100%'} alignItems={'center'} spacing={0}>
        {/* <Text fontWeight="bold" fontSize="24px" color={'#5AB2AE'} textAlign={'center'} mt={'3em'}>
          Video chamada 2
        </Text>
      
        <Text fontWeight="bold" fontSize="18px" color={'#5AB2AE'} textAlign={'center'} mt={'3em'}>
          {JSON.stringify({ channelName, userId, jwt }, null,2)}
        </Text> */}

        <div
          style={{
            background: '#5AB2AE',
            position: 'absolute',
            height: '100dvh',
            width: '100dvw',
          }}
        >
          <JitsiMeeting
            domain={process.env.REACT_APP_TELEMEDICINA_V2}
            roomName={channelName}
            spinner={LoadingImg}
            configOverwrite={{
              subject: 'Telemedicina DeoVita',
              hideConferenceSubject: false,
            }}
            userInfo={{
              displayName: userId,
              email: 'YOUR_EMAIL',
            }}
            jwt={jwt}
            lang="ptBR"
            onApiReady={(externalApi) => handleApiReady(externalApi)}
            onReadyToClose={handleReadyToClose}
            getIFrameRef={handleJitsiIFrameRef1}
          />
          {renderButtons()}
          {/* {renderNewInstance()} */}
          {/* {renderLog()} */}
        </div>
      </VStack>
    </>
  );
}

export default VideoChamada;
